import * as mixpanel from "mixpanel-browser";

if (process.env.NODE_ENV === "production") {
    mixpanel.init("1698b636ac0fd8f5f25d8871c3c0a4b1");
} else {
    mixpanel.init("b7d773bf444eb7c341fc4372910da8c9");
}

